import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { Country } from '@precheckin/models/country.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  private endpoint = `countries`;

  constructor(private apiService: ApiService) { }

  public get(search?: string): Observable<Country[]> {
    let params = new HttpParams();
    if (search) {
      params = params.append('search', search);
    }
    return this.apiService.get<Country[]>(`${this.endpoint}`, { params });
  }
}
